import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation deleteOrganization($id: String!) {
    deleteOrganization(id: $id) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const deleteOrganizationRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id: String;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'organization/delete_organization',
  async (params: {id: String;}, { extra: client }) => {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.deleteOrganization;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const deleteOrganizationSlice = createSlice({
  name: 'delete_organization',
  initialState: initialState,
  reducers: {
    deleteOrganizationClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(deleteOrganizationRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(deleteOrganizationRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(deleteOrganizationRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { deleteOrganizationClear } = deleteOrganizationSlice.actions;

export const deleteOrganization = createSelector(
  (state: RootState) => state.organization.deleteOrganization.result,
  (state: RootState) => state.organization.deleteOrganization.error,
  (state: RootState) => state.organization.deleteOrganization.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default deleteOrganizationSlice.reducer;